import { Drawer } from '@mui/material';

import React from 'react';
import { Link } from 'react-router-dom';

import Logo from 'assets/thro-logo.svg';
import { useAuthContext } from 'utils/hooks/useAuthContext';

import AppMenu from '../Menu';

export const DesktopDrawer = () => {
  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: 'drawer-paper'
      }}
      open
      slotProps={{ root: { style: { display: 'flex' } } }}
      PaperProps={{
        elevation: 4
      }}
    >
      <Link to="/">
        <img src={Logo} alt="logo" className="thro-logo" />
      </Link>
      <AppMenu />
    </Drawer>
  );
};
